import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ProductType } from 'types';
import { media, theme } from 'styles';
import { getCartCurrency } from 'ducks/cart';
import routes, { routeFor } from 'helpers/routes';
import { Breadcrumbs, Container } from 'components/shared';

const StyledHeader = styled.div`
  display: flex;
  background-color: ${theme.colors.blueIce};
  padding: ${theme.sp.xl} 0;
`;

const Wrapper = styled.div`
  margin: ${theme.sp.xl} 0;

  ${media.tablet`
    display: flex;
  `};
`;

const Content = styled.div`
  margin-top: ${theme.sp.xl};

  ${media.tablet`
    width: 40%;
  `};
`;

const Image = styled.div`
  line-height: 0;
  margin-top: ${theme.sp.xl};

  ${media.tablet`
    width: 60%;
    margin: 0;
  `};

  img {
    max-width: 100%;
  }
`;

const Name = styled.h1`
  font-size: 36px;
  line-height: 42px;
  font-weight: 700;
  margin-bottom: ${theme.sp.s};
`;

const Price = styled.h2`
  font-size: 36px;
  line-height: 42px;
  font-weight: 500;
  color: ${theme.colors.royal};
`;

const propTypes = {
  product: ProductType.isRequired,
  currency: PropTypes.string.isRequired,
};

const defaultProps = {};

function Header({ product, currency }) {
  const breadcrumbs = [
    {
      name: 'Home',
      link: `${routes.home.index}`,
    },
    {
      name: 'Services',
      link: `${routes.products.index}`,
    },
    {
      name: `${product.productCategories[0].name}`,
      link: routeFor(
        routes.products.category,
        product.productCategories[0].slug,
      ),
    },
    {
      name: product.name,
      link: routeFor(
        routes.products.show,
        product.productCategories[0].slug,
        product.slug,
      ),
    },
  ];

  return (
    <StyledHeader>
      <Container>
        <Breadcrumbs left breadcrumbs={breadcrumbs} />
        <Wrapper>
          <Content>
            <Name>{product.name}</Name>
            <Price>{product.prices[currency].formattedPrice}</Price>
          </Content>
          <Image>
            <img
              src={`${process.env.GATSBY_MARKETTAP_ASSET_HOST}${
                product.bannerImageUrl.full
              }`}
              alt={product.name}
            />
          </Image>
        </Wrapper>
      </Container>
    </StyledHeader>
  );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const mapStateToProps = state => ({
  currency: getCartCurrency(state),
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/ProductPage/components/Header/Header.jsx